<template>
    <div>
        <ContactModal :companyName="contact.companyName" :jobTitle="contact.job_title" :show="showModal" @hideModal="hideModal">
            <template v-slot:icon>
                <div class="swal-icon swal-icon--warning">
                    <span class="swal-icon--warning__body">
                        <span class="swal-icon--warning__dot"></span>
                    </span>
                </div>
            </template>
            <template v-slot:content>
                <div class="swal-content mt-4" style="text-align: center;">
                    <div class="content-detail mt-2">
                        <h3>ご自身のキャリア登録企業として選択されていないため、受付できません</h3>
                        <p class="mt-4" style="color: red; font-weight: bold;font-size: 18px;">登録企業として選択する必要があります</p>
                    </div>

                    <div class="button-container mt-4">
                        <button class="btn btn-info" @click="proceed()" >登録企業の選択に進む</button>
                    </div>
                </div>
            </template>
        </ContactModal>
    </div>
</template>

<script>
import ContactModal from './ContactModal.vue';
export default {
    name: 'ContactReply',
    props: ['contact', 'showModal'],
    components: { ContactModal },
    methods: {
        hideModal(){
            this.$emit('hideModal');
        },
        proceed(){
            this.$emit('redirectToProfile')
        }
    },
    mounted(){
        console.log('here');
        // console.log(this.contact);
        // this.$refs.contactModal.show();
    }
}
</script>

<style scoped>

.btn-info {
    background-color: #006C6B;
    width: 280px;
    /* padding-left: 30px; */
}

.btn-info.interview {
    padding: 0px;
}

.btn-secondary {
    width: 280px;
}

.btn-info-blue {
    background-color: #2F80ED;
    color: #fff;
    width: 280px;
}

.btn {
    border-radius: 4px;
    font-weight: bold;
}
h3{
    font-weight: bold;
    font-size: 20px;
}

.swal-icon:first-child {
    margin-top: 32px;
}

.swal-icon {
    width: 80px;
    height: 80px;
    border-width: 4px;
    border-style: solid;
    border-radius: 50%;
    padding: 0;
    position: relative;
    box-sizing: content-box;
    margin: 20px auto;
}

.swal-icon--warning {
    border-color: #f8bb86;
    -webkit-animation: pulseWarning .75s infinite alternate;
    animation: pulseWarning .75s infinite alternate;
}

.swal-icon--warning__body, .swal-icon--warning__dot {
    position: absolute;
    left: 50%;
    background-color: #f8bb86;
    width: 7px;
    height: 7px;
    border-radius: 50%;
    margin-left: -4px;
    bottom: -11px;
}

.swal-icon--warning__body {
    width: 5px;
    height: 47px;
    top: 10px;
    border-radius: 2px;
    margin-left: -2px;
}

@media(max-width: 767px) {
    .btn-secondary {
        width: 45%;
        height: 50px;
        font-size: 12px;
    }
    .btn-info,
    .btn-info-blue {
        width: 45%;
        height: 50px;
        padding: 2px;
        font-size: 12px;
        white-space: pre-line;
    }
}
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
    .btn-secondary {
        width: 45%;
        height: 50px;
        font-size: 14px;
    }
    .btn-info,
    .btn-info-blue {
        width: 45%;
        height: 50px;
        padding: 8px;
        font-size: 14px;
    }

}


</style>